import { useNavigate } from 'react-router-dom';
import { useBudgetList } from '../../hooks/useBudgetMutations';
import { LoadingSpinner } from '../../components/shared/LoadingSpinner';

export function BudgetsPage() {
  const navigate = useNavigate();
  const { data: budgets = [], isPending, error } = useBudgetList();

  if (isPending) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <div className="p-6 bg-red-50 border border-red-200 rounded">
        <h2 className="text-red-800 font-semibold">Error loading budgets</h2>
        <p className="text-red-700 mt-2">{error instanceof Error ? error.message : 'An error occurred'}</p>
      </div>
    );
  }

  return (
    <main className="flex-1 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Budget Requests</h1>
          <button
            onClick={() => navigate('/admin/budgets/request')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            New Budget Request
          </button>
        </div>

        {budgets.length === 0 ? (
          <div className="bg-white rounded-lg shadow p-8 text-center">
            <p className="text-gray-500 mb-4">No budget requests yet</p>
            <button
              onClick={() => navigate('/admin/budgets/request')}
              className="text-blue-600 hover:text-blue-700 font-medium"
            >
              Create your first budget request
            </button>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <table className="w-full">
              <thead className="bg-gray-100 border-b">
                <tr>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Title</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">BRG</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Amount</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Status</th>
                  <th className="px-6 py-3 text-left text-sm font-semibold text-gray-900">Created</th>
                </tr>
              </thead>
              <tbody>
                {budgets.map((budget) => (
                  <tr key={budget.budgetRequestId} className="border-b hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <button
                        onClick={() => navigate(`/budgets/${budget.budgetRequestId}`)}
                        className="text-blue-600 hover:text-blue-700 font-medium"
                      >
                        {budget.projectEvent || 'Untitled'}
                      </button>
                    </td>
                    <td className="px-6 py-4 text-gray-700">{budget.brgId}</td>
                    <td className="px-6 py-4 text-gray-700 font-mono">${budget.requestAmount.toFixed(2)}</td>
                    <td className="px-6 py-4">
                      <span style={{
                        padding: '6px 12px',
                        borderRadius: '9999px',
                        fontSize: '14px',
                        fontWeight: 500,
                        backgroundColor: 
                          budget.budgetStatusId === 1 ? '#fef3c7' :
                          budget.budgetStatusId === 2 ? '#dcfce7' :
                          '#fee2e2',
                        color: 
                          budget.budgetStatusId === 1 ? '#92400e' :
                          budget.budgetStatusId === 2 ? '#166534' :
                          '#991b1b'
                      }}>
                        {budget.budgetStatusId === 1 ? 'Pending' : budget.budgetStatusId === 2 ? 'Approved' : 'Denied'}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-gray-700 text-sm">
                      {new Date(budget.requestedDate).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </main>
  );
}
